import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDataProvider } from 'react-admin';
import type { GPDataProvider } from '../index';
import type {
  ReportMerchantOfferSummaryCreate,
  ReportMerchantOfferSummaryCreateParams,
} from '../CustomMethods/Report';
import { type ActionHook, type ActionOptions, stableSerialize } from './types';

export function useReportMerchantOfferSummaryCreate(
  initialArgs?: ReportMerchantOfferSummaryCreateParams,
  options?: ActionOptions<
    ReportMerchantOfferSummaryCreateParams,
    Awaited<ReturnType<ReportMerchantOfferSummaryCreate>>
  >,
): ActionHook<
  ReportMerchantOfferSummaryCreateParams,
  Awaited<ReturnType<ReportMerchantOfferSummaryCreate>>
> {
  const dataProvider = useDataProvider<GPDataProvider>();
  const queryClient = useQueryClient();
  const mutation = useMutation<
    Awaited<ReturnType<ReportMerchantOfferSummaryCreate>>,
    Error,
    ReportMerchantOfferSummaryCreateParams
  >({
    ...options,
    mutationFn: (args) =>
      queryClient.fetchQuery({
        queryKey: [
          'custom-action',
          'reportMerchantOfferSummaryCreate',
          stableSerialize(args ?? initialArgs),
        ],
        queryFn: () =>
          dataProvider.reportMerchantOfferSummaryCreate(
            args ?? initialArgs ?? ({} as ReportMerchantOfferSummaryCreateParams),
          ),
        staleTime: 5 * 60 * 1000,
      }),
  });
  return [
    (args, callOptions) =>
      mutation.mutateAsync(
        args ?? initialArgs ?? ({} as ReportMerchantOfferSummaryCreateParams),
        callOptions,
      ),
    mutation,
  ];
}
